import { Component, OnInit, InjectionToken } from '@angular/core';
import { ToastData, ToastService } from '../../services/toast.service';

@Component({
    selector: 'app-toast',
    templateUrl: './toast.component.html',
    styleUrls: ['./toast.component.scss'],
})
export class ToastComponent implements OnInit {
    constructor(private service: ToastService) {}

    get data(): ToastData[] {
        return this.service.get();
    }

    dismiss(toast: ToastData) {
        this.service.remove(toast);
    }

    takeAction(toast: ToastData) {
        this.service.takeAction(toast);
    }

    ngOnInit() {}
}
